import { Component, Inject, OnInit } from "@angular/core";
import { AbstractControl, FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import { CustomerMapping } from "../../../_model/customer-mapping-response/customer-mapping";
import { CustomerMappingProperty } from "../../../_model/customer-mapping-response/customer-mapping-property";
import { CustomerMappingService } from "../../../service/customer-mapping.service";
import { SnackbarService } from "../../../service/snackbar.service";
import { CustomerMappingArray } from "../../../_model/customer-mapping-response/customer-mapping-array";
import { environment } from '../../../../environments/environment';
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatOptionModule } from "@angular/material/core";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatStepperModule } from "@angular/material/stepper";

import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: 'create-dialog',
  templateUrl: './create-dialog.html',
  standalone: true,
  imports: [MatSlideToggleModule, MatOptionModule, MatCheckboxModule, ReactiveFormsModule, MatProgressSpinnerModule, MatFormFieldModule, MatStepperModule, MatDialogModule, MatInputModule, MatSelectModule, MatButtonModule],
  styleUrls: ['./create-dialog.scss']
})
export class CreateDialog implements OnInit {

  dialogName!: string;

  isLoadingResults = true;
  clientProperties!: Map<string, any>;
  rentokilProperties!: Map<string, any>;

  clientPropertiesKeys!: string[];
  rentokilPropertiesKeys!: string[];

  nameFormGroup!: FormGroup;
  clientFormGroup!: FormGroup;
  rentokilFormGroup!: FormGroup;

  workOrders: string[] = [
    'CORRECTIVE',
    'MAINTENANCE'];
    workOrdersUk: string[] = [
      'JOBS',
      'MAINTENANCE',
      'CALL OUT',
      'FOLLOW-UP',
      'RECOMMENDATION',
      'NO-ACTION',
      'FIELD BIOLOGIST'
    ];
    mappedTo: string[] = [
      'SiteName',
      'PremisePurchaseOrderNo'
    ];
    toggleValue! : boolean;
    stringToggleValue : string = "no";
  fmSystemId!: string;
  clientId!: string;
  us = false;
  europe = false;
  asia = false;
  isNewForm: boolean = true;
  constructor(private dialogRef: MatDialogRef<CreateDialog>,
              private _formBuilder: FormBuilder,
              private customerMappingService: CustomerMappingService,
              private sbService: SnackbarService,
              @Inject(MAT_DIALOG_DATA) private customerMapping: CustomerMappingArray) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    if(environment.region === 'US'){
      this.us = true;
    }
    if(environment.region === 'EUROPE'){
      this.europe = true;
    }
    if(environment.region === 'ASIA'){
      this.asia = true;
    }
    this.initializeForm();
  }

  getClientDisplayName(key: string): string {
    const val: any = this.clientProperties.get(key);
    return (val && typeof val === 'object') ? val.displayName : val;
  }

  getRentokilDisplayName(key: string): string {
    const val: any = this.rentokilProperties.get(key);
    return (val && typeof val === 'object') ? val.displayName : val;
  }


  onToggleChange(event: boolean) { // Use boolean for toggle change event
    this.toggleValue = event; 
    this.stringToggleValue = this.toggleValue ? "yes" : "no";
  }

  getStringToggleValue(): string {
    return this.toggleValue ? "yes" : "no";
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
  getFormControlIndex(key: string): number {
    return this.rentokilPropertiesKeys.indexOf(key);
  }

  onSave(): void {
    if (this.validateForm()) {

       let body: { [key: string]: any } = {
        name: this.nameFormGroup.get('firstCtrl')?.value
      };

      if (this.customerMapping) {
        body['id'] = this.customerMapping.customerMappingId;
      }

      body['clientProperties'] = this.createPropertiesRequestMap(this.clientPropertiesKeys, this.clientControlArray.controls);
      body['rentokilProperties'] = this.createPropertiesRequestMap(this.rentokilPropertiesKeys, this.rentokilControlArray.controls);

      if (this.customerMapping) {
        this.customerMappingService.updateCustomerMapping(body).subscribe(response => this.processResponse(response));
      } else {
        this.customerMappingService.createCustomerMapping(body).subscribe(response => this.processResponse(response));
      }

    } else {
      this.sbService.openDefault('Client and Rentokil properties must have at least one value each');
    }
  }

  validateForm(): boolean {
    return this.nameFormGroup.get('firstCtrl')?.value
    && this.clientControlArray.valid
    && this.rentokilControlArray.valid;
  }

  private processResponse(response: any) {
    if (response.status == 'ERROR') {
      this.sbService.openDefault(response.message);
    } else {
      this.sbService.openDefault('Customer Mapping saved successfully');
      this.dialogRef.close(true);
    }
  }

  // private validateControls(formArray: FormArray): boolean {
  //   return formArray.controls.some(control => control.value);
  // }

  private createPropertiesRequestMap(keys: string[], controls: AbstractControl[]) {
  let propsMap: { [key: string]: string } = {};    
  let i = 0;
    for (const key of keys) {
        const value = controls[i].value;
        if (value && /\S/.test(value)) {
            propsMap[key] = value;
        }
        if (key === 'isInvoicingAllowed') {
            propsMap[key] = controls[i].value ? controls[i].value : 'No' ;// Directly use control value
        }
        if (key === 'invoicePDFAllowed' || key === 'invoiceDataAllowed') {
            propsMap[key] = controls[i].value ? 'Yes' : 'No';
        }
        i++;
    }
    return propsMap;
}

  private initializeForm() {
    this.nameFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.clientFormGroup = this._formBuilder.group({
      clientControlArray: this._formBuilder.array([])
    });
    this.rentokilFormGroup = this._formBuilder.group({
      rentokilControlArray: this._formBuilder.array([])
    });

    if (this.customerMapping) {
      this.nameFormGroup.get('firstCtrl')?.setValue(this.customerMapping.name);
      this.dialogName = 'Edit Customer Mapping';
    } else {
      this.isNewForm = !this.customerMapping;
      this.dialogName = 'Create Customer Mapping';
    }

    this.isLoadingResults = true;
    this.customerMappingService.getMappingProperties().subscribe(response => {
      this.fmSystemId = response.data.fmSystemId;
      this.clientId = response.data.clientId;

      this.clientProperties = response.data.clientProperties;
      this.rentokilProperties = response.data.rentokilProperties;
      this.isLoadingResults = false;

      this.clientPropertiesKeys = Array.from(this.clientProperties.keys());
            // Ensure invoicePDFAllowed and invoiceDataAllowed are at the end if they exist
            const allKeys = Array.from(this.rentokilProperties.keys());
            this.rentokilPropertiesKeys = allKeys.filter(key => key !== 'invoicePDFAllowed' && key !== 'invoiceDataAllowed' && key !== 'isInvoicingAllowed');
            if (allKeys.includes('isInvoicingAllowed')) {
              this.rentokilPropertiesKeys.push('isInvoicingAllowed');
            }
            if (allKeys.includes('invoicePDFAllowed')) {
                this.rentokilPropertiesKeys.push('invoicePDFAllowed');
            }
            if (allKeys.includes('invoiceDataAllowed')) {
                this.rentokilPropertiesKeys.push('invoiceDataAllowed');
            }

      // this.rentokilPropertiesKeys = Array.from(this.rentokilProperties.keys());
      for (const key of this.clientPropertiesKeys) {
        this.addClientControl(this.customerMapping ? this.findInCustomerMapping(this.customerMapping.clientMapping, key) : '');
      }

      // for (const key of this.rentokilPropertiesKeys) {
      //   let initialValue: string | boolean = this.customerMapping
      //     ? this.findInCustomerMapping(this.customerMapping.rentokilMapping, key)
      //     : '';

      //   if (key === 'isInvoicingAllowed' && this.customerMapping && initialValue === 'Yes') {
      //     initialValue = true; // Set toggle to true if value is 'Yes'
      //   }

      //   if ((key === 'invoicePDFAllowed' || key === 'invoiceDataAllowed') && this.customerMapping && initialValue === 'Yes') {
      //     initialValue = true;
      //   }
      //   if (key === 'invoicePDFAllowed') {
      //     const control = this.rentokilControlArray.controls[this.rentokilControlArray.length - 2];
      //     control.disable(); // Disable these controls
      // }
      // this.addRentokilControl(this.customerMapping ? this.findInCustomerMapping(this.customerMapping.rentokilMapping, key) : '');
      // }
      
      this.rentokilPropertiesKeys.forEach(key => {
        let initialValue: string | boolean = this.customerMapping
        ? this.findInCustomerMapping(this.customerMapping.rentokilMapping, key)
        : '';

    if (key === 'isInvoicingAllowed' && this.customerMapping && initialValue === 'Yes') {
        initialValue = 'Yes';
    }

    if ((key === 'invoiceDataAllowed' || key === 'invoicePDFAllowed') && this.customerMapping) {
        initialValue = initialValue === 'Yes'; // Convert "Yes" to true, otherwise false
    }

        // Add rentokil form controls
        this.addRentokilControl(initialValue);

        // Disable 'invoicePDFAllowed', 'invoiceDataAllowed', and 'isInvoicingAllowed' fields for both create and edit forms
        if (key === 'invoicePDFAllowed' || key === 'invoiceDataAllowed' || key === 'isInvoicingAllowed') {
          const control = this.rentokilControlArray.controls[this.rentokilControlArray.length - 1];
          control.disable(); // Disable these controls
        }

      });
    
    

       this.clientPropertiesKeys.forEach((key, index) => {
        const prop = this.clientProperties.get(key);
        if (prop && prop.isMandatory) {
          this.getValidatorsForClientControl(index, key);
        }
      }),
       this.rentokilPropertiesKeys.forEach((key, index) => {
        const prop = this.rentokilProperties.get(key);
        if (prop && prop.isMandatory) {
          this.getValidatorsForRentokilControl(index, key);
        }
      })

    });
  }

  isControlRequired(clientKey: string) {
    // if (['type', 'category', 'requestTypeId'].includes(clientKey)) {
    //   return true;
    // }
    //  return false;
    const prop = this.clientProperties.get(clientKey);
    return prop ? prop.isMandatory : false;
  }
  isRentokilControlRequired(rentokilKey: string) {
    // if (['workOrderType'].includes(rentokilKey)) {
    //   return true;
    // }
    // if (this.fmSystemId === "4" && rentokilKey === 'ProductCode') {
    //   return true;
    // }
    // return false;
    const prop = this.rentokilProperties.get(rentokilKey);
    return prop ? prop.isMandatory : false;
  }

  private get rentokilControlArray() {
    return this.rentokilFormGroup.get('rentokilControlArray') as FormArray;
  }

  private addRentokilControl(value: string | boolean) {
    this.rentokilControlArray.push(this._formBuilder.control(value));
}
  // private addRentokilControl(value: string | boolean, disabled: boolean = false) {
  //   const control = this._formBuilder.control({value: value, disabled: disabled});
  //   this.rentokilControlArray.push(control);
  // }

  private get clientControlArray() {
    return this.clientFormGroup.get('clientControlArray') as FormArray;
  }

  private addClientControl(value: string) {
    this.clientControlArray.push(this._formBuilder.control(value));
  }

  private getValidatorsForClientControl(index: number, controlName: string) {
    this.clientControlArray.controls[index].setValidators([Validators.required]);
    this.clientControlArray.controls[index].updateValueAndValidity();
    //let index: number | null = null; // Initialize index to null

    // if (this.fmSystemId == "1" && this.clientId =="Ampol") {
    //   index = 2;
    // }
    // else if (this.fmSystemId == "1") {
    //   index = 4;
    // }
    // else if (this.fmSystemId == "2") {
    //   index = 2;
    // }
    // else if (this.fmSystemId == "3") {
    //   index = 3;
    // }
    // else if (this.fmSystemId == "9") {
    //   index = 2;
    // }
    // if (index !== null && index >= 0 && index < this.clientControlArray.controls.length) {
    //         this.clientControlArray.controls[index].setValidators([Validators.required]);
    //         this.clientControlArray.controls[index].updateValueAndValidity();
    //       } else {
    //         console.warn(`Could not apply validator for ${controlName}. Invalid index: ${index} or fmSystemId: ${this.fmSystemId}, clientId: ${this.clientId}`);
    //       }
  }

  private getValidatorsForRentokilControl(index:number, controlName: string) {
    this.rentokilControlArray.controls[index].setValidators([Validators.required]);
    this.rentokilControlArray.controls[index].updateValueAndValidity();
  //   let index;
  //   if (this.fmSystemId == "1") {
  //     index = 1;
  //   }
  //   else if (this.fmSystemId == "2") {
  //     index = 1;
  //   }
  //   else if (this.fmSystemId == "3") {
  //     index = 1;
  //   }
  //   else if (this.fmSystemId == "9") {
  //     index = 2;
  //   }
  //   else if (this.fmSystemId == "4") {
  //     index = 5;
  //   }
  //   else {
  //   // Assign a default value for unhandled cases
  //   index = 0; // or any other valid index
  // }
  //   this.rentokilControlArray.controls[index].setValidators([Validators.required]);
  //   this.rentokilControlArray.controls[index].updateValueAndValidity();
  }

  private findInCustomerMapping(customerMappings: CustomerMappingProperty[], key: string): string {
    for (const customerMapping of customerMappings) {
      if (customerMapping.property === key) {
        return customerMapping.value;
      }
    }
    return '';
  }
}
